import React from 'react'
import styled from 'styled-components'
import { devices } from 'Utils/devices'

const IconContainer = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  height:  75px;  
`

const SVG = styled.svg`
  ${({isFromWidgetChoice}) => isFromWidgetChoice && `
    @media ${devices.tablet} {
      width: 50px; 
      height: 55px;
    }`
  }
`

const ChartTreeMapIcon = ({
  isFromWidgetChoice
}) => (
  <IconContainer>
<SVG xmlns="http://www.w3.org/2000/svg" width="81" height="59" isFromWidgetChoice={isFromWidgetChoice} viewBox="0 0 81 59">
  <g id="icon_treemap" transform="translate(-1042 -195)">
    <g id="Rectangle_3235" data-name="Rectangle 3235" transform="translate(1042 195)" fill="#fff" stroke="currentColor" strokeWidth="3">
      <rect width="25" height="59" rx="1" stroke="none"/>
      <rect x="1.5" y="1.5" width="22" height="56" rx="0.5" fill="none"/>
    </g>
    <g id="Rectangle_3236" data-name="Rectangle 3236" transform="translate(1070 195)" fill="#fff" stroke="currentColor" strokeWidth="3">
      <rect width="53" height="26" rx="1" stroke="none"/>
      <rect x="1.5" y="1.5" width="50" height="23" rx="0.5" fill="none"/>
    </g>
    <g id="Rectangle_3237" data-name="Rectangle 3237" transform="translate(1070 223)" fill="#fff" stroke="currentColor" strokeWidth="3">
      <rect width="26" height="31" rx="1" stroke="none"/>
      <rect x="1.5" y="1.5" width="23" height="28" rx="0.5" fill="none"/>
    </g>
    <g id="Rectangle_3240" data-name="Rectangle 3240" transform="translate(1098 223)" fill="#fff" stroke="currentColor" strokeWidth="3">
      <rect width="25" height="18" rx="1" stroke="none"/>
      <rect x="1.5" y="1.5" width="22" height="15" rx="0.5" fill="none"/>
    </g>
    <g id="Rectangle_3241" data-name="Rectangle 3241" transform="translate(1098 243)" fill="#fff" stroke="currentColor" strokeWidth="3">
      <rect width="25" height="11" rx="1" stroke="none"/>
      <rect x="1.5" y="1.5" width="22" height="8" rx="0.5" fill="none"/>
    </g>
  </g>
</SVG>
  </IconContainer>
)

export default ChartTreeMapIcon